import axios, { AxiosInstance } from "axios";
const getUrlDomainApi = () => {
  const hostname = window.location.hostname;
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.")
  ) {
    return process.env.REACT_APP_API_DOMAIN;
  }
  return window.location.origin + "/endpoint/service.html";
};
const axiosRequest: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN,
  headers: {
    //
  },
});

export default axiosRequest;
